<template>
  <div>
    <div :class="wrapperClasses">
      <v-card>
        <div class="d-flex pt-2 px-2">


          <!-- menu start -->
          <v-menu dense offset-x right :key="key">
            <template #activator="{ attrs, on }">
              <v-btn small icon elevation="0" v-bind="attrs" v-on="on">
                <i class="fa-solid fa-bars" style="font-size: 16px;"></i>
              </v-btn>
            </template>
            <v-list class="more-options-menu">

              <v-list-item @click="addToDashboard(message.id)" dense>
                <v-list-item-icon class="mr-2 justify-center">
                  <v-icon small>fa-solid fa-chart-pie</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Add to Explorer</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="refresh(message.id)" dense>
                <v-list-item-icon class="mr-2 justify-center">
                  <v-icon small>fas fa-clone</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Refresh data</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

            </v-list>
          </v-menu>
          <!-- menu end -->
          <v-spacer></v-spacer>
          <v-btn icon small @click="maximize"> <v-icon small>{{ maximized ? 'mdi-arrow-collapse' : 'mdi-arrow-expand' }}
            </v-icon></v-btn>
          <v-btn icon small @click="openInEditMode"> <v-icon small>mdi-pencil</v-icon></v-btn>
        </div>
        <v-divider></v-divider>
        <v-card-text>
          <dashboard-widget :message="message" mini="true"></dashboard-widget>
        </v-card-text>
      </v-card>
    </div>
   
    <v-dialog v-model="dashboardModal.show" width="500px">
      <v-card>
        <v-card-title>
          Add Widget to Explorer
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-5">
          <v-select single-line dense solo label="Add to Dashboard" v-model="selectedDashboard"
          :items="dashboards" item-text="name" item-value="id"

              ></v-select>

        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="red" elevation="0" :disabled="dashboardModal.loading" text @click="closeDashboardModal">
            close
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" elevation="0" @click="dashboardUpdateHandler" :loading="dashboardModal.loading">
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <edit-chart-message ref="editChartMessage"></edit-chart-message>
  </div>
</template>

<script>
/* eslint-disable */
/* eslint-disable no-unused-vars */
import DashboardWidget from './dashboard-widget.vue';
import chartTypes from '../config/chart-types';
import apiService from '../../Dashboard/service/dashboard-widgets.service'
import customDashboardService from '../../Dashboard/service/custom-dashboard.service'
import EditChartMessage from './edit-chart-message.vue';

export default {
  components: {
    DashboardWidget,
    EditChartMessage
  },
  props: ['message'],
  data() {
    return {
      chartTypes: chartTypes,
      maximized: false,
      show: false,
      editMode: false,
      //selected: {},
      key: 0,
      
      dashboards: [],
      selectedDashboard: null,
      dashboardModal: {
        show: false,
        loading: false,

      },
       defaultWidgetWidth: 5,
      defaultWidgetHeight: 3,
      gridColNum: 20,
      gridRowHeight: 100,
      legendOptions: {
        show: true,
        position: 'bottom'
      },
      legendPosition: [{ name: 'Top', value: "top" }, { name: 'Left', value: 'left' },
      { name: 'Bottom', value: 'bottom' }, { name: 'Right', value: 'right' }],
    };

  },
  mounted() {
    customDashboardService.get(this.$route.params.id).then(res => {
      this.dashboards = res.data;
    })
  },
  methods: {
    dashboardUpdateHandler() {
      this.dashboardModal.loading = true;
      var payload = {
        ...this.message,
         width: this.defaultWidgetWidth,
        height: this.defaultWidgetHeight,
        aiGenerated: true,
        pageId: this.selectedDashboard
      }
      if(payload.legend)
      payload.legend=JSON.stringify(payload.legend);
      apiService.fromMessage(payload).then(res => {
        //TODO: display modal with go to the dashboard option.
        this.$dialog.notify.success('Widget added to the dashboard successfully successfully.', {
                    position: 'top-right',
                    timeout: 3000,
                  });
      }).finally(()=>{
        this.dashboardModal.loading=false;
        this.dashboardModal.show=false;
      });


    },
    closeDashboardModal() {
      this.dashboardModal.show = false;
    },
    addToDashboard() {
      this.selectedDashboard = null;
      this.dashboardModal.show = true;
    },
    maximize() {
      this.editMode = false;
      this.$refs.editChartMessage.open(this.message,{editMode:this.editMode})
     
    },
    close() {
      this.editMode = false;
      this.show = false;
    },
    openInEditMode() {
      this.editMode = true;
      this.$refs.editChartMessage.open(this.message,{editMode:this.editMode})
    },
    edit() {
      
      this.editMode = !this.editMode;
      //  this.key=Date.now();
    }
  },
  computed: {
    // dashboards() {
    //   return this.$store.getters['TASK_MANAGER/GET_ENTRIES'];
    // },
    wrapperClasses() {
      if (this.maximized)
        return ['message-chart-wrapper', 'max']
      else
        return ['message-chart-wrapper']
    },
    editing() {
      return this.editMode;
    },
    selected() {
      return structuredClone(this.message || {});
    }
  }
}
</script>

<style>
.message-chart-wrapper {
  width: 500px;
}

.expansion-panel-title {
  background: var(--v-colored_bg-base);
  height: 20px;
  border-top: 2px solid rgba(51, 51, 51, 0.5);
  border-bottom: 2px solid rgba(51, 51, 51, 0.5);
}
</style>